import { makeStyles } from '@mui/styles';
import { Theme } from '@mui/material';

import { STYLE } from 'constants/style';

export const useStyles = makeStyles((theme: Theme) => ({
  container: {
    borderRadius: 4,
  },
  title: {
    fontWeight: 500,
    marginBottom: 8,
    fontSize: 12,
    lineHeight: '16px',
  },
  rulesList: {
    display: 'flex',
    flexDirection: 'column',
    gap: 8,
  },
  ruleItem: {
    display: 'flex',
    alignItems: 'center',
    gap: '4px 8px',
    margin: '0px 2px',
  },
  ruleText: {
    lineHeight: '16px',
    fontSize: 12,
    fontWeight: '400',
  },
  ruleSuccess: {
    color: STYLE.COLOR.SUCCESS,
  },
  ruleError: {
    color: STYLE.COLOR.ERROR,
  },
}));
